module.exports = __webpack_public_path__ + "img/ds3.0f145557.png";